module.exports = __webpack_public_path__ + "img/bckgrdSideBar.8d04092b.jpg";